import Image from "next/image";
import Iconify from "../../iconify";
import Cart from "./cart";
import IconCode from "@/src/lib/iconCode";
import HeaderSearch from "../../common/headerSearch";
import CityList from "../../common/test-search/cityList";
import Link from "next/link";
import { useSelector } from "react-redux";

// import ResponsiveDrawer from "./drawer";
// import LoginPopUp from "../../common/loginPopUp";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import {
    CUSTOMER_CARE_DISPLAY,
    CUSTOMER_CARE_TEL,
    NEXT_IMAGE_CDN,
} from "@/src/lib/util/config";
import useCommon from "@/src/lib/util/useCommon";
import { callHref } from "@/src/lib/util/callUtils";
import React from "react";
import AccountMenu from "./accountMenu";
import dynamic from "next/dynamic";
import useAuth from "@/src/lib/hooks/useAuth";
import { useRouter } from "next/router";
import StickyRight from "../../common/stickyRight";
import CustomButton from "@/src/lib/ui/Button";

const LoginPopUp = dynamic(() => import("../../common/loginPopUp"));
const ResponsiveDrawer = dynamic(() => import("./drawer"));
const AddTestInPatientCart = dynamic(() => import("./addTestInPatientCart"));

const Header = () => {
    const router = useRouter();
    const { isLoggedIn } = useAuth();
        const tollNumber = useSelector((state) => state?.hookCity);

    const [open, setOpen] = React.useState(false);
    const { cityLists } = useCommon();
    const isDesktop = useBreakpoint("(min-width: 767px)");
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => {
        setMounted(true);
    }, []);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    // Match the fallback on the first client render (SSR has no persisted
    // Redux state) to avoid a hydration mismatch; swap in the real number
    // only after mount, same as the other mounted-gated client-only bits below.
    const landlineNo = mounted ? tollNumber?.landlineNo : null;

    const searchHeader = () => {
        return (
            <div
                className={`border border-style border-gray-300 flex flex-row justify-between items-center w-full md:mb-0 mb-2 md:ml-18 rounded-4xl`}
            >
                <div className="rounded-md max-w-36 w-full">
                    <CityList cityLists={cityLists} />
                </div>

                <HeaderSearch
                    textFieldClasses={`border-l border-style border-gray-300 max-w-xl w-full flex items-center justify-center ${
                        isDesktop ? "relative" : ""
                    }`}
                    buttonFieldClasses={"!rounded-full"}
                    inputSize={"small"}
                    layoutShiftToLeft={isDesktop}
                />
            </div>
        );
    };

    return (
        <div className="max-w-6xl mx-auto px-3 md:px-0">
            <StickyRight />
            <div className="py-2 flex flex-row justify-between items-center">
                <div className="md:max-w-2xl max-w-32 w-full flex flex-row justify-between items-center md:gap-2 gap-1">
                    {!mounted ? null : !isDesktop && <ResponsiveDrawer />}

                    <Image
                        className="cursor-pointer w-32 h-12 object-contain"
                        onClick={() => router.push("/")}
                        src={`${NEXT_IMAGE_CDN}/icon/hod_logo.svg`}
                        alt="House Of Diagnostics"
                        width={0}
                        height={0}
                        priority={true}
                        sizes="(max-width: 768px) 100vw, 33vw"
                    />

                    {/* This is for desktop view only */}
                    {!mounted ? null : isDesktop && searchHeader()}
                </div>

                <div className="flex flex-row justify-between items-center md:gap-5 sm:gap-3 gap-2">
                    <Link
                        href={callHref(landlineNo || CUSTOMER_CARE_TEL)}
                        aria-label={`Call customer support at ${landlineNo || CUSTOMER_CARE_DISPLAY}`}
                    >
                        <div
                            className="hidden md:flex"
                            style={{
                                color: "black",
                                fontSize: "18px",
                                fontWeight: "600",
                                display: "flex",
                                alignItems: "center",
                                "&:hover": {
                                    color: "#d01305",
                                },
                            }}
                        >
                            <Iconify
                                icon={IconCode.phoneCall}
                                color="primary"
                                width="24px"
                                className="mr-1"
                            />
                            {landlineNo || CUSTOMER_CARE_DISPLAY}
                        </div>
                    </Link>

                    <Cart />
                    {isLoggedIn ? (
                        <AccountMenu />
                    ) : (
                        <CustomButton
                            variant="outlined"
                            size="small"
                            onClick={handleClickOpen}
                            className="text-primary text-sm"
                        >
                            Login
                        </CustomButton>
                    )}
                </div>
            </div>

            {/* This is for mobile and tablet view only */}
            {!mounted ? null : !isDesktop && searchHeader()}
            <LoginPopUp
                setOpen={setOpen}
                open={open}
                onClose={onClose}
                title="Sign Up / Login"
            />

            <AddTestInPatientCart />
        </div>
    );
};

export default Header;
